// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__eE-Rk","title":"Header_title__3WdoP","left":"Header_left__ttpoR","clinicName":"Header_clinicName__2fSKG"};